import { Alert } from 'components/shared/Alert/Alert';
import Badge from 'components/shared/Badge/Badge';
import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';

import { chargeLimitSelfPayOptions } from './lib/helpers';

const ChargeLimit = ({ value, onChange }) => {
  const activeOption = value?.route_to;
  const config = value?.config ?? {};

  const handleRouteTo = (route_to) =>
    onChange({ route_to, config: route_to === activeOption ? config : {} });
  const handleConfig = (patch) =>
    onChange({ route_to: activeOption, config: { ...config, ...patch } });

  const renderChildren = (optionValue) => {
    if (optionValue === 'set-dollar-amount') {
      return (
        <div className="flex flex-col gap-4 px-1">
          <CurrencyInput
            label="Maximum auto-charge amount"
            onValueChange={(next) => handleConfig({ dollar_cap: Number(next) || 0 })}
            value={config.dollar_cap ?? 0}
            className="max-w-[406px]"
          />
          <Alert
            message="Recommended amount: $300–$400"
            icon="bulb-filled"
            variant="lighter"
            className="w-full"
          />
        </div>
      );
    }
    return null;
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Typography variant="label" size="large" weight="medium">
          Charge limit (cap)
        </Typography>
        <Typography variant="p" size="small">
          Set a limit on the amount that can be charged to a patient's card on file for incidental
          balances after treatment and/or insurance remittance.
        </Typography>
      </div>
      <div className="flex flex-col gap-2">
        {chargeLimitSelfPayOptions.map((option) => {
          const isActive = option.value === activeOption;
          const children = renderChildren(option.value);
          return (
            <Disclosure
              key={option.value}
              isOpen={isActive}
              onToggle={() => handleRouteTo(option.value)}
              customTitle={
                <div className="flex gap-2">
                  <Typography variant="p" size="small" weight="medium">
                    {option.title}
                  </Typography>
                  {option.recommended && (
                    <Badge text="Recommended" variant="lighter" color="primary" size="small" />
                  )}
                </div>
              }
              disableOpen={!children}
              caption={option.caption}
              className="w-full"
              buttonClassName="py-2"
              bodyClassName="flex-col gap-0"
              radio>
              {children}
            </Disclosure>
          );
        })}
      </div>
    </div>
  );
};

export default ChargeLimit;
